import * as Mod1 from "./discourse/adapters/discourse-post-event-adapter";
import * as Mod2 from "./discourse/adapters/discourse-post-event-event";
import * as Mod3 from "./discourse/adapters/discourse-post-event-invitee";
import * as Mod4 from "./discourse/adapters/discourse-post-event-nested-adapter";
import * as Mod5 from "./discourse/adapters/discourse-post-event-reminder";
import * as Mod6 from "./discourse/admin-calendar-route-map";
import * as Mod7 from "./discourse/api-initializers/discourse-group-timezones";
import * as Mod8 from "./discourse/components/admin-holidays-list-item";
import * as Mod9 from "./discourse/components/admin-holidays-list";
import * as Mod10 from "./discourse/components/bulk-invite-sample-csv-file";
import * as Mod11 from "./discourse/components/category-calendar";
import * as Mod12 from "./discourse/components/compact-event-editor";
import * as Mod13 from "./discourse/components/composer-event-editor";
import * as Mod14 from "./discourse/components/csv-uploader";
import * as Mod15 from "./discourse/components/discourse-post-event/chat-channel";
import * as Mod16 from "./discourse/components/discourse-post-event/creator";
import * as Mod17 from "./discourse/components/discourse-post-event/dates";
import * as Mod18 from "./discourse/components/discourse-post-event/description";
import * as Mod19 from "./discourse/components/discourse-post-event/event-status";
import * as Mod20 from "./discourse/components/discourse-post-event/image";
import * as Mod21 from "./discourse/components/discourse-post-event/index";
import * as Mod22 from "./discourse/components/discourse-post-event/invitee";
import * as Mod23 from "./discourse/components/discourse-post-event/invitees";
import * as Mod24 from "./discourse/components/discourse-post-event/livestream";
import * as Mod25 from "./discourse/components/discourse-post-event/location";
import * as Mod26 from "./discourse/components/discourse-post-event/more-menu";
import * as Mod27 from "./discourse/components/discourse-post-event/status";
import * as Mod28 from "./discourse/components/discourse-post-event/url";
import * as Mod29 from "./discourse/components/event-date";
import * as Mod30 from "./discourse/components/event-node-view";
import * as Mod31 from "./discourse/components/full-calendar";
import * as Mod32 from "./discourse/components/group-timezones/index";
import * as Mod33 from "./discourse/components/group-timezones/new-day";
import * as Mod34 from "./discourse/components/group-timezones/time-traveller";
import * as Mod35 from "./discourse/components/group-timezones/timezone";
import * as Mod36 from "./discourse/components/livestream/embeddable-chat-channel";
import * as Mod37 from "./discourse/components/livestream/mobile-livestream-chat-icon";
import * as Mod38 from "./discourse/components/livestream/modal/mobile-embeddable-chat-modal";
import * as Mod39 from "./discourse/components/livestream/responsive-livestream-chat-icon";
import * as Mod40 from "./discourse/components/modal/post-event-builder";
import * as Mod41 from "./discourse/components/modal/post-event-bulk-invite";
import * as Mod42 from "./discourse/components/modal/post-event-invite-user-or-group";
import * as Mod43 from "./discourse/components/modal/post-event-invitees/index";
import * as Mod44 from "./discourse/components/modal/post-event-invitees/user";
import * as Mod45 from "./discourse/components/post-calendar";
import * as Mod46 from "./discourse/components/region-input";
import * as Mod47 from "./discourse/components/toggle-invitees";
import * as Mod48 from "./discourse/components/upcoming-events-calendar";
import * as Mod49 from "./discourse/components/upcoming-events-list";
import * as Mod50 from "./discourse/connectors/before-main-outlet/embeddable-chat-channel-connector.gjs";
import * as Mod51 from "./discourse/connectors/before-topic-list-body/category-calendar.gjs";
import * as Mod52 from "./discourse/connectors/calendar-subscriptions-feeds/event-feeds.gjs";
import * as Mod53 from "./discourse/connectors/category-custom-settings/show-event-category-sorting-settings.gjs";
import * as Mod54 from "./discourse/connectors/chat-join-channel-button/join-channel-message.gjs";
import * as Mod55 from "./discourse/connectors/discovery-list-container-top/category-events-calendar.gjs";
import * as Mod56 from "./discourse/connectors/header-topic-title-suffix/event-date-container.gjs";
import * as Mod57 from "./discourse/connectors/topic-list-after-title/event-badge.gjs";
import * as Mod58 from "./discourse/connectors/user-custom-preferences/region.gjs";
import * as Mod59 from "./discourse/controllers/admin-plugins/show/discourse-calendar-holidays";
import * as Mod60 from "./discourse/controllers/discourse-post-event-upcoming-events";
import * as Mod61 from "./discourse/controllers/discourse-post-event-upcoming-events/index";
import * as Mod62 from "./discourse/controllers/discourse-post-event-upcoming-events/mine";
import * as Mod63 from "./discourse/discourse-event-upcoming-events-route-map";
import * as Mod64 from "./discourse/helpers/format-event-name";
import * as Mod65 from "./discourse/helpers/format-future-date";
import * as Mod66 from "./discourse/initializers/add-create-event-composer-action";
import * as Mod67 from "./discourse/initializers/add-event-ui-builder";
import * as Mod68 from "./discourse/initializers/add-events-create-topic-button";
import * as Mod69 from "./discourse/initializers/add-upcoming-events-to-sidebar";
import * as Mod70 from "./discourse/initializers/calendar-admin-plugin-configuration-nav";
import * as Mod71 from "./discourse/initializers/disable-sort";
import * as Mod72 from "./discourse/initializers/discourse-calendar";
import * as Mod73 from "./discourse/initializers/discourse-post-event-decorator";
import * as Mod74 from "./discourse/initializers/event-relative-date";
import * as Mod75 from "./discourse/initializers/livestream-chat-overrides";
import * as Mod76 from "./discourse/lib/calendar-locale";
import * as Mod77 from "./discourse/lib/calendar-view-helper";
import * as Mod78 from "./discourse/lib/colors";
import * as Mod79 from "./discourse/lib/discourse-markdown/discourse-calendar";
import * as Mod80 from "./discourse/lib/discourse-markdown/discourse-post-event-block";
import * as Mod81 from "./discourse/lib/discourse-markdown/livestream-preview";
import * as Mod82 from "./discourse/lib/event-preview";
import * as Mod83 from "./discourse/lib/event-recurrence";
import * as Mod84 from "./discourse/lib/event-relative-date";
import * as Mod85 from "./discourse/lib/format-event-for-calendar";
import * as Mod86 from "./discourse/lib/full-calendar-default-options";
import * as Mod87 from "./discourse/lib/guess-best-date-format";
import * as Mod88 from "./discourse/lib/open-event-composer";
import * as Mod89 from "./discourse/lib/raw-event-helper";
import * as Mod90 from "./discourse/lib/regions";
import * as Mod91 from "./discourse/lib/round-time";
import * as Mod92 from "./discourse/models/discourse-post-event-event-stats";
import * as Mod93 from "./discourse/models/discourse-post-event-event";
import * as Mod94 from "./discourse/models/discourse-post-event-invitee";
import * as Mod95 from "./discourse/models/discourse-post-event-invitees";
import * as Mod96 from "./discourse/models/discourse-post-event-reminder";
import * as Mod97 from "./discourse/pre-initializers/rich-editor-extension";
import * as Mod98 from "./discourse/pre-initializers/transformers";
import * as Mod99 from "./discourse/routes/discourse-post-event-upcoming-events";
import * as Mod100 from "./discourse/routes/discourse-post-event-upcoming-events/default-index";
import * as Mod101 from "./discourse/routes/discourse-post-event-upcoming-events/default-mine";
import * as Mod102 from "./discourse/routes/discourse-post-event-upcoming-events/index";
import * as Mod103 from "./discourse/routes/discourse-post-event-upcoming-events/mine";
import * as Mod104 from "./discourse/services/create-event-composer";
import * as Mod105 from "./discourse/services/discourse-post-event-api";
import * as Mod106 from "./discourse/services/discourse-post-event-service";
import * as Mod107 from "./discourse/services/embeddable-chat";
import * as Mod108 from "./discourse/services/post-calendar";
import * as Mod109 from "./discourse/templates/admin-plugins/show/discourse-calendar-holidays";
import * as Mod110 from "./discourse/templates/discourse-post-event-upcoming-events";
import * as Mod111 from "./discourse/templates/discourse-post-event-upcoming-events/index";
import * as Mod112 from "./discourse/templates/discourse-post-event-upcoming-events/mine";
const compatModules = {
  "discourse/adapters/discourse-post-event-adapter": Mod1,
  "discourse/adapters/discourse-post-event-event": Mod2,
  "discourse/adapters/discourse-post-event-invitee": Mod3,
  "discourse/adapters/discourse-post-event-nested-adapter": Mod4,
  "discourse/adapters/discourse-post-event-reminder": Mod5,
  "discourse/admin-calendar-route-map": Mod6,
  "discourse/api-initializers/discourse-group-timezones": Mod7,
  "discourse/components/admin-holidays-list-item": Mod8,
  "discourse/components/admin-holidays-list": Mod9,
  "discourse/components/bulk-invite-sample-csv-file": Mod10,
  "discourse/components/category-calendar": Mod11,
  "discourse/components/compact-event-editor": Mod12,
  "discourse/components/composer-event-editor": Mod13,
  "discourse/components/csv-uploader": Mod14,
  "discourse/components/discourse-post-event/chat-channel": Mod15,
  "discourse/components/discourse-post-event/creator": Mod16,
  "discourse/components/discourse-post-event/dates": Mod17,
  "discourse/components/discourse-post-event/description": Mod18,
  "discourse/components/discourse-post-event/event-status": Mod19,
  "discourse/components/discourse-post-event/image": Mod20,
  "discourse/components/discourse-post-event/index": Mod21,
  "discourse/components/discourse-post-event/invitee": Mod22,
  "discourse/components/discourse-post-event/invitees": Mod23,
  "discourse/components/discourse-post-event/livestream": Mod24,
  "discourse/components/discourse-post-event/location": Mod25,
  "discourse/components/discourse-post-event/more-menu": Mod26,
  "discourse/components/discourse-post-event/status": Mod27,
  "discourse/components/discourse-post-event/url": Mod28,
  "discourse/components/event-date": Mod29,
  "discourse/components/event-node-view": Mod30,
  "discourse/components/full-calendar": Mod31,
  "discourse/components/group-timezones/index": Mod32,
  "discourse/components/group-timezones/new-day": Mod33,
  "discourse/components/group-timezones/time-traveller": Mod34,
  "discourse/components/group-timezones/timezone": Mod35,
  "discourse/components/livestream/embeddable-chat-channel": Mod36,
  "discourse/components/livestream/mobile-livestream-chat-icon": Mod37,
  "discourse/components/livestream/modal/mobile-embeddable-chat-modal": Mod38,
  "discourse/components/livestream/responsive-livestream-chat-icon": Mod39,
  "discourse/components/modal/post-event-builder": Mod40,
  "discourse/components/modal/post-event-bulk-invite": Mod41,
  "discourse/components/modal/post-event-invite-user-or-group": Mod42,
  "discourse/components/modal/post-event-invitees/index": Mod43,
  "discourse/components/modal/post-event-invitees/user": Mod44,
  "discourse/components/post-calendar": Mod45,
  "discourse/components/region-input": Mod46,
  "discourse/components/toggle-invitees": Mod47,
  "discourse/components/upcoming-events-calendar": Mod48,
  "discourse/components/upcoming-events-list": Mod49,
  "discourse/connectors/before-main-outlet/embeddable-chat-channel-connector": Mod50,
  "discourse/connectors/before-topic-list-body/category-calendar": Mod51,
  "discourse/connectors/calendar-subscriptions-feeds/event-feeds": Mod52,
  "discourse/connectors/category-custom-settings/show-event-category-sorting-settings": Mod53,
  "discourse/connectors/chat-join-channel-button/join-channel-message": Mod54,
  "discourse/connectors/discovery-list-container-top/category-events-calendar": Mod55,
  "discourse/connectors/header-topic-title-suffix/event-date-container": Mod56,
  "discourse/connectors/topic-list-after-title/event-badge": Mod57,
  "discourse/connectors/user-custom-preferences/region": Mod58,
  "discourse/controllers/admin-plugins/show/discourse-calendar-holidays": Mod59,
  "discourse/controllers/discourse-post-event-upcoming-events": Mod60,
  "discourse/controllers/discourse-post-event-upcoming-events/index": Mod61,
  "discourse/controllers/discourse-post-event-upcoming-events/mine": Mod62,
  "discourse/discourse-event-upcoming-events-route-map": Mod63,
  "discourse/helpers/format-event-name": Mod64,
  "discourse/helpers/format-future-date": Mod65,
  "discourse/initializers/add-create-event-composer-action": Mod66,
  "discourse/initializers/add-event-ui-builder": Mod67,
  "discourse/initializers/add-events-create-topic-button": Mod68,
  "discourse/initializers/add-upcoming-events-to-sidebar": Mod69,
  "discourse/initializers/calendar-admin-plugin-configuration-nav": Mod70,
  "discourse/initializers/disable-sort": Mod71,
  "discourse/initializers/discourse-calendar": Mod72,
  "discourse/initializers/discourse-post-event-decorator": Mod73,
  "discourse/initializers/event-relative-date": Mod74,
  "discourse/initializers/livestream-chat-overrides": Mod75,
  "discourse/lib/calendar-locale": Mod76,
  "discourse/lib/calendar-view-helper": Mod77,
  "discourse/lib/colors": Mod78,
  "discourse/lib/discourse-markdown/discourse-calendar": Mod79,
  "discourse/lib/discourse-markdown/discourse-post-event-block": Mod80,
  "discourse/lib/discourse-markdown/livestream-preview": Mod81,
  "discourse/lib/event-preview": Mod82,
  "discourse/lib/event-recurrence": Mod83,
  "discourse/lib/event-relative-date": Mod84,
  "discourse/lib/format-event-for-calendar": Mod85,
  "discourse/lib/full-calendar-default-options": Mod86,
  "discourse/lib/guess-best-date-format": Mod87,
  "discourse/lib/open-event-composer": Mod88,
  "discourse/lib/raw-event-helper": Mod89,
  "discourse/lib/regions": Mod90,
  "discourse/lib/round-time": Mod91,
  "discourse/models/discourse-post-event-event-stats": Mod92,
  "discourse/models/discourse-post-event-event": Mod93,
  "discourse/models/discourse-post-event-invitee": Mod94,
  "discourse/models/discourse-post-event-invitees": Mod95,
  "discourse/models/discourse-post-event-reminder": Mod96,
  "discourse/pre-initializers/rich-editor-extension": Mod97,
  "discourse/pre-initializers/transformers": Mod98,
  "discourse/routes/discourse-post-event-upcoming-events": Mod99,
  "discourse/routes/discourse-post-event-upcoming-events/default-index": Mod100,
  "discourse/routes/discourse-post-event-upcoming-events/default-mine": Mod101,
  "discourse/routes/discourse-post-event-upcoming-events/index": Mod102,
  "discourse/routes/discourse-post-event-upcoming-events/mine": Mod103,
  "discourse/services/create-event-composer": Mod104,
  "discourse/services/discourse-post-event-api": Mod105,
  "discourse/services/discourse-post-event-service": Mod106,
  "discourse/services/embeddable-chat": Mod107,
  "discourse/services/post-calendar": Mod108,
  "discourse/templates/admin-plugins/show/discourse-calendar-holidays": Mod109,
  "discourse/templates/discourse-post-event-upcoming-events": Mod110,
  "discourse/templates/discourse-post-event-upcoming-events/index": Mod111,
  "discourse/templates/discourse-post-event-upcoming-events/mine": Mod112,
};
export default compatModules;
